import React from 'react';
import {
  Link,
  useHistory,
  useRouteMatch,
} from 'react-router-dom';

import Hidden from '@material-ui/core/Hidden';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import IconVisibility from '@material-ui/icons/Visibility';
import IconReceipt from '@material-ui/icons/Receipt';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

import { useShoppingCartContext } from '@/contexts/useShoppingCartContext';

import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  label: {
    paddingTop: theme.spacing(0.2),
    paddingBottom: theme.spacing(0.2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    textAlign: 'center',
    borderRadius: theme.spacing(0.5),
    cursor: 'pointer',
  },
  tabLabel: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.grey[800],
    backgroundColor: theme.palette.grey[300],
    display: 'inline-block',
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
  },
  tabLabelActive: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.common.black,
  },
  rightToolbox: {
    float: 'none',
    [theme.breakpoints.up('sm')]: { float: 'right' },
  },
}));

const Header = () => {
  const classes = useStyles();
  const history = useHistory();

  const { shoppingCart } = useShoppingCartContext();

  return (
    <>
      <Hidden only="sm">
        <Box
          className={clsx({ [classes.label]: true })}
          position="absolute"
          style={{ right: 60, marginTop: -60, padding: 0 }}
          onClick={() => history.push('/pre-orders/shopping-cart')}
        >
          <ShoppingCartIcon />
          {
            shoppingCart && Object.keys(shoppingCart).length > 0 && <RedDot />
          }
        </Box>
      </Hidden>
      <Box px={0} my={1} whiteSpace="nowrap" overflow="auto">
        <Hidden only="xs">
          <Box my={2} />
        </Hidden>
        <Link to="/pre-orders">
          <Box
            className={clsx({
              [classes.label]: true,
              [classes.tabLabel]: true,
              [classes.tabLabelActive]: !!useRouteMatch('/pre-orders'),
            })}
          >
            <Grid
              container
              alignItems="center"
              wrap="nowrap"
              spacing={1}
            >
              <Grid item>
                <Box display="flex">
                  <AccessTimeIcon />
                </Box>
              </Grid>
              <Grid item>
                <Typography style={{ fontWeight: 'bold' }} noWrap>限時預購</Typography>
              </Grid>
            </Grid>
          </Box>
        </Link>
        <Box
          style={{ display: 'none' }} // NOTE: We temporary disable this function
          className={clsx({
            [classes.label]: true,
            [classes.tabLabel]: true,
            [classes.tabLabelActive]: !!useRouteMatch('/pre-orders/personal/watched-group-pre-orders'),
          })}
          onClick={() => history.push('/pre-orders/personal/watched-group-pre-orders')}
        >
          <Grid
            container
            alignItems="center"
            wrap="nowrap"
            spacing={1}
          >
            <Grid item>
              <Box display="flex">
                <IconVisibility />
              </Box>
            </Grid>
            <Grid item>
              <Typography style={{ fontWeight: 'bold' }} noWrap>
                關注中
                <Hidden only="xs">的團購</Hidden>
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box display="inline-block" className={clsx({ [classes.rightToolbox]: true })}>
          <Link to="/pre-orders/personal/purchased-orders">
            <Box
              className={clsx({
                [classes.label]: true,
                [classes.tabLabel]: true,
                [classes.tabLabelActive]: !!useRouteMatch('/pre-orders/personal/purchased-orders'),
              })}
            >
              <Grid
                container
                alignItems="center"
                wrap="nowrap"
                spacing={1}
              >
                <Grid item>
                  <Box display="flex">
                    <IconReceipt />
                  </Box>
                </Grid>
                <Grid item>
                  <Typography style={{ fontWeight: 'bold' }} noWrap>
                    訂單
                    <Hidden only="xs">記錄</Hidden>
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Link>
          <Hidden only="xs">
            <Link to="/pre-orders/shopping-cart">
              <Box
                className={clsx({
                  [classes.label]: true,
                  [classes.tabLabel]: true,
                  [classes.tabLabelActive]: !!useRouteMatch('/pre-orders/shopping-cart'),
                })}
                position="relative"
              >
                <Grid
                  container
                  alignItems="center"
                  wrap="nowrap"
                  spacing={1}
                >
                  <Grid item>
                    <Box display="flex">
                      <ShoppingCartIcon />
                    </Box>
                  </Grid>
                  <Grid item>
                    <Typography style={{ fontWeight: 'bold' }} noWrap> 購物車</Typography>
                  </Grid>
                </Grid>
                {
                  shoppingCart && Object.keys(shoppingCart).length > 0 && <RedDot />
                }
              </Box>
            </Link>
          </Hidden>
        </Box>
        <Hidden only="xs">
          <Box my={2} />
        </Hidden>
      </Box>
    </>
  );
};

const RedDot = () => (
  <div style={{
    position: 'absolute',
    width: 8,
    height: 8,
    backgroundColor: 'red',
    top: -2,
    right: -2,
    borderRadius: 10,
  }}
  />
);

export default Header;
